// Canonical Studio scene editing rules. Keep ordering and positions in scene_catalog.
export const LAUNCH_PLUS_PLANS = Object.freeze(["launch","growth","pro","business","custom","nation_owner"]);
export function isLaunchPlusPlan(key){
  return LAUNCH_PLUS_PLANS.includes(String(key||"").trim().toLowerCase());
}
export function reorderSceneCatalog(scenes,movingId,targetId,placeAfter=false){
  if(!Array.isArray(scenes)||!movingId||movingId===targetId)return scenes;
  const current=[...scenes],source=current.findIndex(scene=>scene.id===movingId);
  if(source<0||!current.some(scene=>scene.id===targetId))return scenes;
  const [moving]=current.splice(source,1);
  current.splice(current.findIndex(scene=>scene.id===targetId)+(placeAfter?1:0),0,moving);
  return current;
}
export function placeSceneGraphic(scenes,sceneId,key,pos){
  if(!Array.isArray(scenes)||!sceneId||!key||!pos)return scenes;
  const normalized={x:Math.max(0,Math.min(1,Number(pos.x)||0)),y:Math.max(0,Math.min(1,Number(pos.y)||0))};
  return scenes.map(scene=>scene.id===sceneId?{
    ...scene,graphic_positions:{...(scene.graphic_positions||{}),[key]:normalized}
  }:scene);
}
